import produce from 'immer';
import { COMMON_TYPES, DEV_PLAN_INTERVAL, GET_DEV_PLAN_TYPES, NAVIGATE_STEP_KEYS, PURCHASE_DEV_PLAN_TYPES, SEND_EMAIL_VERIFICATION_TYPES, VERIFY_EMAIL_TYPES, } from './types';
export var getInitialState = function () { return ({
    accountConfigLoading: false,
    devPlanInterval: DEV_PLAN_INTERVAL.ANNUALLY,
    devPlanTrialPeriod: 0,
    devPlans: [],
    devPlansError: null,
    devPlansLoading: false,
    emailVerification: {
        email: '',
        verificationCode: '',
        verificationSent: false,
        verified: false,
        valid: false,
    },
    sendEmailVerificationError: null,
    sendEmailVerificationLoading: false,
    sendEmailVerificationResponse: null,
    verifyEmailProcessing: false,
    verifyEmailResponse: null,
    verifyEmailError: null,
    selectedDevPlanId: '',
    step: NAVIGATE_STEP_KEYS.START,
    purchasedDevPlan: null,
    purchaseDevPlanError: null,
    purchaseDevPlanLoading: false,
    isHold: false,
}); };
var statesReducer = function (currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case GET_DEV_PLAN_TYPES.REQUEST:
                state.devPlansLoading = true;
                state.devPlansError = null;
                state.devPlans = null;
                break;
            case GET_DEV_PLAN_TYPES.SUCCESS:
                state.devPlansLoading = false;
                state.devPlansError = null;
                state.devPlans = action.devPlans;
                break;
            case GET_DEV_PLAN_TYPES.FAILURE:
                state.devPlansLoading = false;
                state.devPlansError = action.error;
                state.devPlans = null;
                break;
            case COMMON_TYPES.SELECT_DEV_PLAN:
                state.selectedDevPlanId = action.devPlanId;
                break;
            case COMMON_TYPES.NAVIGATE_STEPS:
                state.step = action.step;
                break;
            case COMMON_TYPES.SHOULD_HOLD:
                state.isHold = true;
                break;
            case COMMON_TYPES.RESET_STATE:
                state.accountConfigLoading = false;
                state.devPlans = [];
                state.devPlansError = null;
                state.devPlansLoading = false;
                state.emailVerification.email = '';
                state.emailVerification.verificationCode = '';
                state.emailVerification.verificationSent = false;
                state.emailVerification.verified = false;
                state.emailVerification.valid = false;
                state.purchasedDevPlan = null;
                state.sendEmailVerificationError = null;
                state.sendEmailVerificationResponse = null;
                state.sendEmailVerificationLoading = false;
                state.step = NAVIGATE_STEP_KEYS.START;
                state.verifyEmailProcessing = false;
                state.verifyEmailResponse = null;
                state.verifyEmailError = null;
                state.selectedDevPlanId = '';
                state.isHold = false;
                break;
            case COMMON_TYPES.SET_DEV_PLAN_INTERVAL:
                state.devPlanInterval = action.interval;
                break;
            case PURCHASE_DEV_PLAN_TYPES.REQUEST:
                state.purchaseDevPlanLoading = true;
                state.purchaseDevPlanError = null;
                state.purchasedDevPlan = null;
                break;
            case PURCHASE_DEV_PLAN_TYPES.SUCCESS:
                state.purchaseDevPlanLoading = false;
                state.purchaseDevPlanError = null;
                state.purchasedDevPlan = action.devPlan;
                break;
            case PURCHASE_DEV_PLAN_TYPES.FAILURE:
                state.purchaseDevPlanLoading = false;
                state.purchaseDevPlanError = action.error;
                state.purchasedDevPlan = null;
                state.step = NAVIGATE_STEP_KEYS.CARD_DETAILS;
                break;
            case COMMON_TYPES.SET_EMAIL_VERIFICATION_DATA:
                state.emailVerification[action.key] = action.data;
                break;
            case SEND_EMAIL_VERIFICATION_TYPES.REQUEST:
                state.sendEmailVerificationLoading = true;
                state.emailVerification.verified = false;
                state.emailVerification.verificationSent = false;
                state.sendEmailVerificationError = null;
                break;
            case SEND_EMAIL_VERIFICATION_TYPES.SUCCESS:
                state.sendEmailVerificationLoading = false;
                state.emailVerification.verified = false;
                state.emailVerification.verificationSent = true;
                state.sendEmailVerificationError = null;
                break;
            case SEND_EMAIL_VERIFICATION_TYPES.FAILURE:
                state.sendEmailVerificationLoading = false;
                state.emailVerification.verified = false;
                state.emailVerification.verificationSent = false;
                state.sendEmailVerificationError = action.error;
                break;
            case VERIFY_EMAIL_TYPES.REQUEST:
                state.verifyEmailProcessing = true;
                state.verifyEmailResponse = null;
                state.verifyEmailError = null;
                state.emailVerification.verified = false;
                break;
            case VERIFY_EMAIL_TYPES.SUCCESS:
                state.verifyEmailProcessing = false;
                state.emailVerification.verified = true;
                state.verifyEmailResponse = action.response;
                state.verifyEmailError = null;
                state.emailVerification.email = '';
                break;
            case VERIFY_EMAIL_TYPES.FAILURE:
                state.verifyEmailProcessing = false;
                state.emailVerification.verified = false;
                state.verifyEmailResponse = null;
                state.verifyEmailError = action.error;
                break;
            case COMMON_TYPES.SET_DEV_PLAN_TRIAL:
                state.devPlanTrialPeriod = action.trial;
        }
    });
};
export default statesReducer;
